import {Box, Button, ButtonGroup, Divider, IconButton, Modal, TextField, Typography} from '@mui/material';
import {Bento, Close, Delete, Edit, Save} from '@mui/icons-material';
import React, {useEffect, useState} from 'react';
import LoaderComponent from '../../loaders/LoaderComponent';
import {API} from '../../../utils/Constants';
import RequestSvc from '../../../services/RequestSvc';
import OfferFollowChart from '../../charts/followOffer/OfferFollowChart';

export default function ChartFollowOfferWindow(
    {
        showChartDataWindow,
        setShowChartDataWindow,
        item
    }
) {

    /*  INIT VARS   */

    /**
     * Estilo para el layout principal de la ventana modal.
     * @type {{border: string, boxShadow: number, padding: number, transform: string, backgroundColor: string, top: string, borderRadius: string, left: string, width: number, position: string}}
     */
    const styleMain = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 520,
        backgroundColor: 'white',
        border: '2px solid #000',
        boxShadow: 24,
        padding: 16,
        borderRadius: '20px',
        overflow: 'hidden',
    }
    /**
     * Objeto de la clase que se usa para hacer request
     * @type {RequestSvc}
     */
    const requestSvc = new RequestSvc();
    /**
     *  Flag que indica el grafico que se esta mostrando
     */
    const [chartShown, setChartShown] = useState('page');
    /**
     * Estilo para el boton pagina
     * @type {{backgroundColor: (string), color: (string), textTransform: string}}
     */
    const stylePageBtn = {
        textTransform: 'none',
        backgroundColor: chartShown === 'domain' ? 'var(--btn-color-gray-deselected)' : 'var(--btn-color-primary-blue)',
        color: chartShown === 'page' ? 'white' : 'black'
    }
    /**
     * Estilo para el btn dominio
     * @type {{backgroundColor: (string), color: (string), textTransform: string}}
     */
    const styleDomainBtn = {
        textTransform: 'none',
        backgroundColor: chartShown === 'page' ? 'var(--btn-color-gray-deselected)' : 'var(--btn-color-orange)',
        color: chartShown === 'page' ? 'black' : 'white'
    }
    /**
     * Contiene los datos para el grafico de page
     */
    const [dataChartPage, setDataChartPage] = useState({});
    /**
     *  Contiene los datos para el grafico de dominio
     */
    const [dataChartDomain, setDataChartDomain] = useState({});
    /**
     * Flag que indica si ya se cargaron los datos para el grafico de pagina
     */
    let [isPageChartDataLoaded, setIsPageChartDataLoaded] = useState(false);
    /**
     * Flag que indica si ya se cargaron los datos para el grafico de dominio
     */
    let [isDomainChartDataLoaded, setIsDomainChartDataLoaded] = useState(false);
    /**
     * Flag que indica si si se esta realizando una peticion al servidor
     */
    const [isLoading, setIsLoading] = useState(true);
    /**
     * Endpoint para hacer la carga de los datos para los graficos
     * @type {string}
     */
    let endPoint = API.OFFER_TRACKING_CHART.replace('%1s', item.OffersFollo_ID);
    /**
     * Contiene el numero nombre para el seguimiento
     */
    const [newFollowName, setNewFollowName] = useState(item.Nombre);
    /**
     * Flag que indica si mostrar o no el boton de guardar.
     */
    let [showSaveBtn, setShowSaveBtn] = useState(false);

    /*  END VARS    */


    /*  INIT EVENTS */

    /**
     * Evento para cerrar la ventana modal
     * @param showChart
     */
    const onClickBtns = (showChart) => {
        setChartShown(showChart)
    }

    /**
     * Cerrar la ventana modal.
     */
    const handleClose = () => {
        setShowChartDataWindow(false, null)
    }

    /**
     * En este evento se evalua si mostrar o no el boton de guardar.
     * @param inputValue
     */
    const onChangeFollowNameField = (inputValue) => {
        let value = inputValue.replace(/\s+/g, ' ')
        setNewFollowName(value)
        if (value.trim() !== item.Nombre && value.length > 0) {
            setShowSaveBtn(true)
        } else {
            setShowSaveBtn(false)
        }
    }

    const onclickSaveButton = () => {
        setIsLoading(true)
        updateFollowName();
    }

    const onclickDeleteFollow = () => {
        setIsLoading(true)
        deleteFollow();
    }

    /*  END EVENTS  */


    /*  INIT METHODS    */

    /**
     * Metodo en el que se realiza la carga de los datos para el grafico de pagina.
     * @returns {Promise<void>}
     */
    const loadDataFollowPage = async () => {
        let url = endPoint.replace('%2s', 'FanPage');
        let response = await requestSvc.get(url);
        if (response.code !== 200) {
            alert('Mostrar algun error');
        }
        setDataChartPage(response);
        isPageChartDataLoaded = true;
        checkIsLoading();
    }
    /**
     * Metodo en el que se realiza la carga de los datos para el grafico de dominio.
     * @returns {Promise<void>}
     */
    const loadDataFollowDomain = async () => {
        let url = endPoint.replace('%2s', 'Domain');
        let response = await requestSvc.get(url);
        if (response.code !== 200) {
            alert('Mostrar algun error')
        }
        setDataChartDomain(response);
        isDomainChartDataLoaded = true;
        checkIsLoading();
    }
    /**
     * Metodo que se utiliza para verificar si se esta realizando una carga.
     */
    const checkIsLoading = () => {
        setTimeout(() => {
            if (isDomainChartDataLoaded && isPageChartDataLoaded) {
                setIsLoading(false)
            }
        }, 1000)
    }

    /**
     * Actualizar el nombre del seguimiento.
     * @returns {Promise<void>}
     */
    const updateFollowName = async () => {
        let payload = {
            Nombre: newFollowName
        }
        let response = await requestSvc.put(API.OFFER_FOLLOW + item.OffersFollo_ID, payload)
        if (response.code !== 200) {
            alert(response.message);
            setIsLoading(false)
            handleClose()
            return;
        }
        item.Nombre = newFollowName;
        setTimeout(() => {
            setIsLoading(false)
        }, 1000)
    }

    /**
     * Eliminar el siguimiento
     * @returns {Promise<void>}
     */
    const deleteFollow = async () => {
        let response = await requestSvc.delete(API.OFFER_FOLLOW + item.OffersFollo_ID);
        if (response.code !== 204) {
            alert(response.message);
            setIsLoading(false)
            handleClose()
            return;
        }
        item.Nombre = null;
        item.OffersFollo_ID = null
        setIsLoading(false)
        handleClose()
    }

    /*  END METHODS */

    useEffect(() => {
        loadDataFollowPage()
        loadDataFollowDomain()
    }, []);

    return (
        <div className={'main-layout-modal-window'}>
            <Modal open={showChartDataWindow}
                   onClose={handleClose}>
                <div style={styleMain}>
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <IconButton
                            size='large'
                            sx={{
                                alignSelf: 'end',
                                position: 'relative',
                                marginTop: '-12px',
                                marginBottom: '4px'
                            }}
                            onClick={handleClose}>
                            <Close fontSize='inherit'/>
                        </IconButton>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'flex-end'
                        }}>
                            <Bento sx={{color: 'action.active', mr: 1, my: 0.5}}/>
                            <TextField label='Nombre del seguimiento'
                                       size='small'
                                       variant='standard'
                                       value={newFollowName}
                                       sx={{width: '250px'}}
                                       onChange={(e) => onChangeFollowNameField(e.target.value)}/>
                            {
                                showSaveBtn && (
                                    <Save fontSize='medium' sx={{color: 'black', my: 0.5, ml: 1, cursor: 'pointer'}}
                                          onClick={onclickSaveButton}/>
                                )
                            }
                            {
                                !isLoading && (
                                    <Delete fontSize='medium' sx={{color: 'black', ml: 1, my: 0.5, cursor: 'pointer'}}
                                            onClick={onclickDeleteFollow}/>
                                )
                            }
                        </Box>
                    </div>
                    <div style={{display: 'block', textAlign: 'center', marginTop: '24px'}}>
                        <ButtonGroup disableElevation size='large' variant='contained'
                                     sx={{
                                         backgroundColor: 'white',
                                         '.MuiButtonGroup-grouped:not(:last-of-type)': {
                                             borderColor: 'white',
                                         }
                                     }}>
                            <Button
                                disabled={isLoading}
                                sx={stylePageBtn} onClick={e => onClickBtns('page')}>Página< /Button>
                            <Button
                                disabled={isLoading}
                                sx={styleDomainBtn} onClick={e => onClickBtns('domain')}>Dominio</Button>
                        </ButtonGroup>
                    </div>
                    <Divider style={{marginTop: '16px'}}/>
                    <Typography component={'div'}>
                        <Box
                            sx={{
                                fontSize: 14,
                                fontWeight: 'bold',
                                color: 'black',
                                textAlign: 'center',
                                marginTop: '24px'
                            }}>Anuncios en el día</Box>
                    </Typography>
                    <div style={{
                        display: 'block',
                        textAlign: 'center',
                        minHeight: '380px',
                        maxHeight: '380px',
                        width: '100%'
                    }}>
                        {
                            isLoading ? (
                                <LoaderComponent/>
                            ) : (
                                <OfferFollowChart
                                    chartShown={chartShown}
                                    dataChart={chartShown === 'page' ? dataChartPage : dataChartDomain}/>
                            )
                        }
                    </div>
                </div>
            </Modal>
        </div>
    )
}